import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Sectors from "@/components/Sectors";
import Process from "@/components/Process";
import Work from "@/components/Work";
import Why from "@/components/Why";
import Team from "@/components/Team";
import ContactCta from "@/components/ContactCta";
import Footer from "@/components/Footer";

function App() {
    return (
        <div className="bg-ink text-cream">
            <Header />
            <main>
                <Hero />
                <Services />
                <Sectors />
                <Process />
                <Work />
                <Why />
                <Team />
                <ContactCta />
            </main>
            <Footer />
        </div>
    );
}

export default App;
